import { scorRu } from './scor';
const ru = {
  "translation": {
    scor: scorRu,
    "back": "Назад",
    "selectAppLanguage": "Выберите язык приложения",
    "russianLang": "Русский",
    "englishLang": "Английский",
    "youAlwaysCanChangeLangInPreferences": "Вы всегда сможете поменять язык в настройках",
    "continuePhrase": "Продолжить",
    "cancel": "Отмена",
    "chatImagesPreview": "Фото перед отправкой",
    "chatPasteMoreImages": "Можно вставить ещё фото из буфера обмена.",
    "phoneCodeUkraine": "Украина (+380)",
    "phoneCodeBelarus": "Беларусь (+375)",
    "phoneCodeUSA": "США (+1)",
    "phoneCodeRussia": "РФ (+7)",
    "phoneCodeSwitzerland": "Швейцария (+41)",
    "phoneCodeUAE": "ОАЭ (+971)",
    "phoneCodeKazakhstan": "Казахстан (+7)",
    "phoneCodeEstonia": "Эстония (+372)",
    "phoneCodeBelgium": "Бельгия (+32)",
    "phoneCodeLithuania": "Литва (+370)",
    "phoneCodeCanada": "Канада (+1)",
    "phoneCodeCzech": "Чехия (+420)",
    "phoneCodeSpain": "Испания (+34)",
    "phoneCodeJapan": "Япония (+81)",
    "inputPhoneNumber": "Введите номер телефона",
    "somethingWentWrongPleaseContactSupport": "Что-то пошло не так. Пожалуйста, обратитесь в поддержку.",
    "verification": "Верификация",
    "requestCodeIn": "Запросить код через {{time}} сек.",
    "codeHasBeenSentToNumber": "Код отправлен на номер",
    "smsCode": "Код",
    "requestCodeAgain": "Запросить код еще раз",
    "checkYourConnectionError": "Сервер недоступен. Проверьте подключение к сети.",
    "serverError": "Ошибка сервера. Пожалуйста, повторите попытку позже.",
    "otpAttemptsLimitExceededError": "The number of attempts to enter the code has been exceeded",
    "setupAccessCode": "Задайте код доступа",
    "repeatAccessCode": "Повторите код доступа",
    "enterAccessCode": "Введите код доступа",
    "invalidPincode": "Неправильный пароль",
    "pincodeDoesNotMatch": "Пароль не совпадает",
    "forgotPassword": "Забыли пароль?",
    "biometricLoginMessage": "Войти в систему",
    "biometricSetupMessage": "Использовать биометрию как основной способ авторизации",
    "doYouWantToChooseBiometricsAsTheMainLoginMethod": "Хотите выбрать биометрию как основной способ авторизации?",
    "yesAnswer": "Да",
    "noAnswer": "Нет",
    "biometry": "Биометрия",
    "otpTooManyAttempts": "Вы ввели неправильный код 3 раза подряд и не сможете авторизоваться в системе в течении 10 минут. Попробуйте повторить попытку через {{time}}",
    "biometryVerifyIdentity": "Подтвердите личность",
    "biometryAuthentification": "Авторизация",
    "biometryNotRecognized": "Не распознано",
    "biometrySettings": "Настройки",
    "biometrySettingsDescription": "Разрешите биометрию на вашем устройстве",
    "biometrySuccess": "Совпадение найдено",
    "portfolioLabel": "Портфель",
    "ordersLabel": "Заявки",
    "chatLabel": "Чаты",
    "profileLabel": "Профиль",
    "yourPortfolio": "Ваш портфель",
    "analytics": "Аналитика",
    "displayPortfolioChartInfoNeedApiKeys": "Для отображения информации по портфелю необходимо ввести номер счёта и API",
    "portfolioChartInputData": "Ввести данные",
    "chartPeriodWeek": "Неделя",
    "chartPeriodMonth": "Месяц",
    "chartPeriodMonth3": "3 мес",
    "chartPeriodMonth6": "6 мес",
    "chartPeriodCurYear": "Тек. год",
    "chartPeriodYear": "Год",
    "chartPeriodAllHistory": "Все",
    "error": "Ошибка",
    "tryAgain": "Повторить попытку",
    "portfolioChartDataIsEmpty": "Уважаемый клиент! Сейчас мы загружаем историю Вашего портфеля. График будет доступен в течении суток!",
    "goal": "Цель",
    "createGoal": "Создать цель",
    "createGoalDescription": "Создайте цель, чтобы инвестировать в своё будущее.",
    "createGoalDescription2": "Можно создать несколько целей для разных счетов. Не более одной цели на счет.",
    "portfolioSectionTitle": "Денежные средства",
    "portfolioOpenedPositionsTitle": "Открытые позиции",
    "portfolioDealsHistoryTitle": "История сделок",
    "goalProgress": "{{current}} из {{desired}}",
    "okUppercased": "ОК",
    "portfolioNoApiKeysTitle": "Информация по портфелю",
    "displayPortfolioNeedApiKeys": "Для отображения информации по портфелю необходимо ввести номер счёта и API",
    "portfolioInputData": "Ввести данные",
    "openedPositionsQuantity": "{{quantity}} шт. {{price}}",
    "dealsHistoryTableTicker": "Тикер",
    "dealsHistoryTableDate": "Дата",
    "dealsHistoryTableQuantity": "Кол-во",
    "dealsHistoryTableResult": "Результат",
    "dealsHistoryTableGrossProfit": "Брутто прибыль",
    "dealsHistoryTableFees": "Комиссии",
    "dealsHistoryTableOpenFee": "Комиссия за открытие",
    "dealsHistoryTableCloseFee": "Комиссия за закрытие",
    "dealsHistoryTableTotalFees": "Итого комиссий",
    "showDetails": "Показать детали",
    "hideDetails": "Скрыть детали",
    "operationTypeBuyAsset": "Покупка актива",
    "operationTypeSellAsset": "Продажа актива",
    "operationTypeBlockFunds": "Блокировка средств",
    "operationTypeUnblockFunds": "Разблокировка средств",
    "operationTypeDealFee": "Комиссия за сделку",
    "operationTypeSuccessFee": "Комиссия Success Fee",
    "operationTypeUnlockAsset": "Разблокировка актива",
    "operationTypeUnknown": "Неизвестная операция",
    "dealsHistoryTableOperations": "Операции",
    "noOperationsFound": "Операции не найдены",
    "loadingOperations": "Загрузка операций...",
    "noDealsFound": "Сделки не найдены",
    "listIsEmpty": "Список пуст",
    "apiKeys": "Ключи API",
    "accountNumber": "Номер счета",
    "portfolioSettings": "Настройка портфеля",
    "events": "Мероприятия",
    "createReport": "Формирование отчёта",
    "portfolio": "Портфель",
    "companies": "Компании",
    "income": "Доход",
    "replenishment": "Пополнение",
    "circulation": "Оборот",
    "withdrawal": "Вывод",
    "companiesCount1": "{{count}} компания",
    "companiesCount2": "{{count}} компании",
    "companiesCount3": "{{count}} компания",
    "companiesCount4": "{{count}} компаний",
    "noDataForSelectedPeriod": "Нет данных для выбранного периода",
    "eventBuyStocks": "Покупка ценной бумаги",
    "eventSellStocks": "Продажа ценной бумаги",
    "eventBuyCurrency": "Покупка валюты",
    "eventSellCurrency": "Продажа валюты",
    "eventUnknownOperation": "Неизвестная операция",
    "eventCommissionWithAmount": "Комиссия {{amount}}",
    "today": "Сегодня",
    "yesterday": "Вчера",
    "reports": "Отчеты",
    "brokerageReport": "Брокерский отчет",
    "brokerageReportDescription": "Какими бумагами владеете, сколько денег внесли и вывели",
    "sendReportToEmail": "Сформировать",
    "periodToLabel": "Период до",
    "periodFromLabel": "Период от",
    "email": "Email",
    "invalidEmail": "Неверный email",
    "fieldIsRequired": "Обязательное поле",
    "reportSent": "Отчет отправлен на почту",
    "newGoal": "Новая цель",
 "createGoalForm1Description1": "Для начала давайте определимся с “базой”, от которой можно отталкиваться для выстраивания стратегии по достижению поставленных планов:",
    "initialDepositLabel": "$ Стартовый вклад",
    "desiredPassiveIncomeLabel": "$ Желаемый пассивный доход",
    "desiredPassiveIncomeHint": "Желаемый ежемесячный пассивный доход от инвестиций",
    "goalAgeLabel": "Возраст-ориентир к цели",
    "goalAgeHint": "В каком возрасте Вы хотите достигнуть цели",
    "createGoalForm2Title": "Доходы",
    "createGoalForm2Description1": "Отлично! Но для более точного расчета нам нужно чуть больше данных.",
    "currentIncomeLabel": "$ Ваш текущий ежемесячный доход",
    "incomeShareLabel": "Доля от доходов %",
    "incomeShareHint": "Доля от доходов, которая пойдет на накопление сбережений",
    "monthlySavingsLabel": "$ Сумма ежемесячных сбережений",
    "replenishmentMonthLabel": "Месяц пополнения",
    "replenishmentMonthHint": "С какого месяца по счёту после первого взноса вы планируете ежемесячно вносить средства",
    "createGoalForm3Title": "Расходы",
    "createGoalForm3Description1": "Отлично, мы почти закончили, остались последние штрихи.",
    "createGoalForm3Description2": "Планируете ли вы какие-либо расходы? Если нет, пропустите данный шаг.",
    "createGoalForm3Description3": "Через сколько месяцев после достижения выхода на желаемый пассивный доход вы хотите сделать эту трату?",
    "expectedSpendingsAmountLabel": "$ Ожидаемая сумма трат",
    "expectedSpendingsAmountHint": "Введите ожидаемую сумму данной траты",
    "spendingMonthLabel": "Месяц траты",
    "createGoalForm4Title": "Остальное",
    "createGoalForm4Description1": "Супер! Теперь давайте дадим название вашей цели. Как только мы закончим, вы сможете видеть прогресс в ее достижении.",
    "goalNameLabel": "Название цели",
    "goalAmountLabel": "Цель",
    "howManyMonthsToWithdrawLabel": "Через сколько месяцев снять",
    "howManyMonthsToWithdrawHint": "С какого месяца пополняем ежемесячно",
    "next": "Далее",
    "goalCancelCreatingTitle": "Отменить создание?",
    "goalCancelCreatingText": "Вы уверены что хотите отменить создание? Все введенные данные будут утеряны",
    "getBack": "Вернуться",
    "cancelAction": "Отменить",
    "create": "Создать",
    "select": "Выбрать",
    "goalAge": "Возраст",
    "fieldMaxNum": "Максимально допустимое значение для ввода: {{num}}",
    "fieldMinNum": "Минимальное допустимое значение для ввода: {{num}}",
    "personalInfo": "Персональная информация",
    "phoneNumber": "Номер телефона",
    "notifications": "Уведомления",
    "pushNotifications": "Пуш уведомления",
    "sms": "SMS",
    "security": "Безопасность",
    "loginUsingBiometry": "Вход по биометрии",
    "settings": "Настройки",
    "appLanguage": "Язык приложения",
    "changeSecurityCode": "Изменить код доступа",
    "logout": "Выйти",
    "useAdditionalPhoneForSms": "Использовать доп. телефон для SMS",
    "additionalPhone": "Доп. телефон",
    "specifyPhoneNumber": "Указать",
    "add": "Добавить",
    "invalidPhoneNumber": "Неверный номер телефона",
    "enterNewAccessCode": "Задайте новый код доступа",
    "enterOldAccessCode": "Введите старый код доступа",
    "accessCodeHasBeenUpdated": "Код доступа был обновлен",
    "updateAccessCode": "Обновить код доступа",
    "goalCreated": "Цель создана",
    "orders": "Заявки",
    "orderBuyAction": "Покупка",
    "orderSellAction": "Продажа",
    "orderUnknownAction": "Неизвестность",
    "orderBuyMarginAction": "Покупка с маржой",
    "orderSellShortAction": "Продажа с маржой",
    "orderByMarket": "По рынку",
    "confirmOrder": "Подтвердить",
    "ordersCurrentStatusGroup": "Текущие",
    "ordersClosedStatusGroup": "Закрытые",
    "orderID": "Номер",
    "orderDate": "Дата",
    "orderName": "Название",
    "orderOperation": "Операция",
    "orderStatus": "Статус",
    "orderPrice": "Цена",
    "orderType": "Тип заявки",
    "orderQuantity": "Кол-во акций",
    "orderCreatedAt": "Дата создания заявки",
    "orderAmount": "Сумма",
    "orderRemain": "Остаток",
    "orderExpiration": "Срок",
    "orderStatusIgnored": "Проигнорирован",
    "orderStatusReceived": "Получен",
    "orderStatusCancelInProgress": "В процессе отмены",
    "orderStatusActive": "Активен",
    "orderStatusSent": "Отправлен",
    "orderStatusPartiallyFilled": "Частично заполнен",
    "orderStatusPartiallyDone": "Частично исполнен",
    "orderStatusDone": "Исполнен",
    "orderStatusPartiallyCanceled": "Частично отменен",
    "orderStatusAdminDeclined": "Заявка была отменена, обратитесь к своему менеджеру",
    "orderStatusRejected": "Отклонен",
    "orderStatusExpired": "Истек",
    "orderStatusPartiallyDoneAndExpired": "Частично исполнен и истек",
    "orderStatusSendingError": "Ошибка отправки",
    "orderStatusCancelError": "Ошибка отмены",
    "orderStatusNew": "Новый",
    "orderStatusProcessed": "Выполнен",
    "orderStatusClientDeclined": "Отменен",
    "orderStatusInvalidOrderStatus": "Некорректный статус заявки. Пожалуйста, обратитесь к своему менеджеру.",
    "orderStatusDeclined": "Отклонен",
    "orderStatusUnknown": "Неизвестный",
    "orderStopPrice": "Стоп цена",
    "orderLimitPrice": "Лимитная цена",
    "orderVolume": "Объём",
    "orderTypeMarket": "Рыночный приказ",
    "orderTypeLimit": "Приказ по заданной цене",
    "orderTypeStop": "Рыночный cтоп-приказ",
    "orderTypeStopLimit": "Стоп-приказ по заданной цене",
    "orderTypeUnknown": "Неизвестный",
    "orderCompletedAt": "Исполнен",
    "orderExpirationDay": "До конца торговой сессии",
    "orderExpirationDay24h": "День/ночь или ночь/день",
    "orderExpirationUntilCanceled": "До отмены",
    "orderExpirationUnknown": "Неизвестный",
    "orderIpoOrderType": "IPO",
    "orderPortfolioShare": "Процент от портфеля",
    "sell": "Продать",
    "buy": "Купить",
    "orderUnderstand": "Понятно",
    "orderConfirmation": "Подтверждение заявки",
    "ordersNoApiKeysDescription": "Для отображения заявок необходимо ввести номер счёта и API",
    "ordersEnterApiKeys": "Ввести данные",
    "apiKeysAllDoneTitle": "Все готово!",
    "apiKeysProposalToConnectDescription": "Вы успешно зарегистрировались в приложении. Осталось совсем немного –подключить аккаунты брокеров.",
    "connect": "Подключить",
    "apiKeysConnectLater": "Подключить позже",
    "connectBrokerAccountTitle": "Подключение брокера",
    "tradernetBroker": "Tradernet",
    "freedomBroker": "Freedom",
    "tinkoffBroker": "Т-Инвестиции",
    "finamBroker": "Финам",
    "selectBrokerDescription": "Выберите для подключения брокера, которым вы пользуетесь. Это позволит отслеживать портфель и операции по нему в приложении",
    "tradernetBrokerConnectDescription": "Для полноценной работы потребуется вести али-ключи и номер счета. Это можно сделать автоматически, получив два смс-кода, или вручную.",
    "brokerExitSetup": "Закончить настройку",
    "brokerConnectManually": "Вручную",
    "brokerConnectAutomatically": "Автоматически",
    "tradernetAuthEnterPhoneDescription": "Связанный с вашим аккаунтом Freedom Finance",
    "tradernetAuthVerifyPhoneTitle": "Авторизируйтесь в FREEDOM finance",
    "tradernetAuthVerifyPhoneDescription": "Мы самостоятельно свяжемся с брокером по апи. От вас требуется только подтвердить авторизацию. Введите код подтверждения от FREEDOM finance, он придет по смс",
    "tradernetTokenVerifyOtpTitle": "Подтвердите создание токена",
    "tradernetTokenVerifyOtpDescription": "Для полноценной работы приложения вам понадобится токен Freedom Finance, мы уже запросили его. Подтвердите создание токена кодом из смс, создание токена кодом из смс.",
    "tradernetAddKeysManually": "Добавить вручную",
    "somethingWentWrong": "Что-то пошло не так",
    "failedToCreateFreedomFinanceToken": "Для полноценной работы приложения необходимо ввести ваш счёт и ключи API. Следуйте подсказкам на экране, чтобы добавить их вручную.",
    "getApiKeys": "Получить ключи API",
    "skip": "Пропустить",
    "done": "Готово",
    "theApplicationIsReady": "Приложение готово к работе",
    "apiKeysGoToHome": "На главную",
    "apiPublicKey": "Публичный ключ",
    "apiPrivateKey": "Приватный ключ",
    "brokerAccounts": "Аккаунты брокеров",
    "unknownBroker": "Неизвестный",
    "brokerAccount": "Аккаунт брокера",
    "brokerAccountNotFound": "Аккаунт брокера не найден",
    "edit": "Редактировать",
    "brokerAccountHasBeenUpdated": "Аккаунт брокера был успешно обновлен",
    "save": "Сохранить",
    "delete": "Удалить",
    "attention": "Внимание",
    "areYouSureDeleteBrokerAccount": "Вы действительно хотите удалить этот аккаунт брокера?",
    "chatCommunityManager": "Комьюнити Менеджер",
    "chatPersonalManager": "Персональный менеджер",
    "chatSystemMessages": "Системные Уведомления",
    "chatUnknownName": "Чат",
    "chatMessagePlaceholder": "Сообщение...",
    "chatCopyMessage": "Скопировать текст",
    "chatRepeatSending": "Повторить отправку",
    "filesCount1": "{{count}} файл",
    "filesCount2": "{{count}} файла",
    "filesCount3": "{{count}} файл",
    "filesCount4": "{{count}} файлов",
    "openFileNoPermission": "Нет прав на просмотр файла",
    "openFileFormatDoesNotSupport": "Не поддерживается выбранный тип файла",
    "openFileNotFound": "Файл не найден",
    "cancelOrder": "Отменить заявку",
    "cancelOrderConfirmationText": "Вы уверены что хотите отменить эту заявку?",
    "closeAction": "Закрыть",
    "search": "Поиск",
    "fileUploadingError": "Ошибка загрузки файла",
    "analyticsWithdrawal": "Вывод средств",
    "loginHeadTitle": "Авторизация",
    "notFoundHeadTitle": "Не найдено",
    "balance": "Баланс",
    "accountAlreadyConnected": "Аккаунт уже подключен",
    "tradernetSelectAccount": "Выбор счета брокера",
    "tradernetSelectAccountDescription": "Выберите счет брокера. Это позволит отслеживать портфель и операции по нему в приложении.",
    "tinkoffBrokerConnectDescription": "Для работы потребуется вести токен аккаунта. Следуйте подсказкам на экране, чтобы добавить его.",
    "tinkoffBrokerConnectStep1_1": "Авторизируйтесь в личном кабинете ",
    "tinkoffBrokerConnectStep1_2": "по ссылке",
    "tinkoffBrokerConnectStep2": "Пролистайте страницу до раздела Токены и нажмите “Выпустить токен” ",
    "tinkoffBrokerConnectStep3": "Выберите токен полного доступа, скопируйте его и вставьте токен в поле",
    "tinkoffAddingToken": "Добавление токена",
    "token": "Токен",
    "connectBrokerAction": "Подключить счет брокера",
    "accountNotFound": "Счет не найден",
    "brokerAccountHasBeenDeleted": "Аккаунт брокера был успешно удален",
    "accountLabel": "Брокерский счет",
    "formHasError": "Формы была заполнена с ошибками. Пожалуйста, исправьте их и попробуйте снова.",
    "orderCanceled": "Заявка успешно отменена",
    "orderConfirmed": "Заявка успешно принята",
    "sendMessage": "Отправить сообщение",
    "selectChat": "Выберите чат",
    "chatNotFound": "Чат не найден",
    "attachFiles": "Прикрепить файлы",
    "filesUploading": "Загрузка файлов",
    "fileIsTooBigMb": "Файл \"{{name}}\" слишком большой. Размер файла не может превышать {{size}} MiB.",
    "peDeals": "PE сделки",
    "myDealsLabel": "Мои активы",
    "newDealsLabel": "Новые сделки",
    "p2pDealsLabel": "Вторичные сделки",
    "myOrdersLabel": "Мои заявки",
    "makePERequest": "Оформите заявку Private Equity ",
    "makePERequestDescription": "Покупка доли непубличных компаний в рамках частных раундов финансирования до выхода на IPO.  ",
    "selectService": "Выбор услуги",
    "myDealsTitle": "Мои сделки",
    "newDealsTitle": "Новые сделки",
    "p2pDealsTitle": "Вторичные сделки",
    "myOrdersTitle": "Мои заявки",
    "dealStartedAt": "Дата входа в сделку",
    "dealEndedAt": "Дата выхода из сделки",
    "sharesQuantity": "Кол-во акций",
    "sharesVolume": "Объем акций",
    "dealOrderType": "Тип заявки",
    "dealOrderTypeBuy": "Покупка",
    "dealOrderTypeSell": "Продажа",
    "dealOrderStatus": "Статус заявки",
    "dealOrderStatusWaitForApproval": "Ожидает подтверждения",
    "dealOrderStatusActive": "Активная",
    "dealOrderStatusCompleted": "Выполненная",
    "dealOrderStatusCanceled": "Отмененная",
    "dealOrderCreatedAt": "Дата создания заявки",
    "dealOrderSellPrice": "Цена продажи акций",
    "dealOrderBuyPrice": "Цена покупки акций",
    "currentSharesPrice": "Текущая цена за акцию",
    "unknown": "Неизвестный",
    "areYouSureYouWantToCancelOrder": "Вы уверены что хотите отменить заявку?",
    "currentPeOrders": "Текущие",
    "closedPeOrders": "Закрытые",
    "peCompanyDetails": "Детали о компании",
    "peCompanyFoundationDate": "Основание",
    "peCompanyHeadOffice": "Головной офис",
    "peCompanySector": "Сектор",
    "peCompanyIndustry": "Индустрия",
    "peCompanyRevenue": "Выручка",
    "peCompanyEmployees": "Сотрудники",
    "peCompanyBusinessModel": "Бизнес модель",
    "peCompanyTakeovers": "Поглощений",
    "peCompanyWebsite": "Сайт",
    "peCompanyDescription": "Описание",
    "peCompanyValue": "Оценка",
    "peCompanyInvestors": "Инвесторы",
    "peCompanyCompetitors": "Конкуренты",
    "peCompanyTeam": "Команда",
    "peInvest": "Инвестировать",
    "orderWasCanceled": "Заявка была отменена",
    "sharesQuantityLabel": "Кол-во акций",
    "sharesPriceLabel": "{{currency}} Цена за акцию",
    "sharesBuyVolumeLabel": "{{currency}} Сумма покупки",
    "sharesSellVolumeLabel": "{{currency}} Сумма продажи",
    "peMakeRequest": "Оформить заявку",
    "peOrderCreated": "Заявка была создана",
    "activePeDeals": "Активные",
    "closedPeDeals": "Закрытые",
    "servicesLabel": "Услуги",
    "peCompanyTitle": "Компания",
    "peSharesDealPrice": "Цена сделки акций",
    "peOperationType": "Тип заявки",
    "confirm": "Подтвердить",
    "serviceTemplateDescription": "Описание",
    "serviceTemplateForWhomDescription": "Кому",
    "templateEntryPriceValue": "от {{price}}",
    "templateEntryPriceLabel": "Порог входа",
    "peCompanyReport": "Отчёт",
    "download": "Скачать",
    "loadingProcess": "Загрузка...",
    "navCommunity": "Сообщество",
    "AI": "ИИ",
    "navMobileApp": "Мобильное приложение",
    "navServices": "Услуги",
    "navMediaPortal": "Медиапортал",
    "navAccount": "Личный кабинет",
    "authWarningText": "Никому не сообщайте код из СМС и/или свой пароль. Настоящий сотрудник SharesPro никогда их не спросит.\nУбедитесь, что код пришел от отправителя SharesPro или в push-уведомлении приложения SharesPro.\n\nНажимая кнопку «Продолжить», вы подтверждаете согласие на обработку персональных данных и принимаете условия пользовательского соглашения.",
    "signInSharespro": "Вход в SharesPro",
    "authorization": "Авторизация",
    "enterCodeFromSms": "Укажите код из SMS",
    "navMain": "Главная",
    "navSettings": "Настройки",
    "navScor": "SCOR",
    "areYouSureYouWanToLogout": "Вы уверены что хотите выйти из аккаунта?",
    "selectGenderMale": "Мужской",
    "selectGenderFemale": "Женский",
    "phoneLabel": "Телефон",
    "firstNameLabel": "Имя",
    "lastNameLabel": "Фамилия",
    "middleNameLabel": "Отчество",
    "emailLabel": "Email",
    "birthdayLabel": "Дата рождения",
    "genderLabel": "Пол",
    "navAccounts": "Счета",
    "profilePhoneInputDescription": "Чтобы привязать новый телефон, напишите в поддержку или позвоните вашему перснальному менеджеру, если вы являйтесь  клиентом  SharesPro.",
    "pageTitleAccounts": "Привязанные брокерские счета",
    "brokerAccountStatusValid": "Подключено",
    "brokerAccountStatusInvalid": "Ошибка",
    "brokerAccountStatusNotFilled": "Подключается",
    "newAccountTitle": "Новый счет",
    "newAccountText": "Подключив счет, вы сможете отслеживать его динамику и аналитику портфеля.",
    "selectBrokerTitle": "Выбор брокера",
    "connectTinkoffBrokerTitle": "Подключение счёта Т-Инвестиции",
    "tinkoffCode": "Код",
    "connectTradernetBrokerTitle": "Подключение счёта Цифраброкер",
    "tradernetBrokerConnectStep1_1": "Авторизируйтесь в личном кабинете ",
    "tradernetBrokerConnectStep1_2": "по ссылке",
    "tradernetBrokerConnectStep2_1": "Сгенерируйте API ключ ",
    "tradernetBrokerConnectStep2_2": "по ссылке",
    "tradernetBrokerConnectStep3": "Нажмите кнопку \"Создать новую пару ключей\".",
    "tradernetBrokerConnectStep4": "Скопируйте и вставьте в поля публичный и секретный ключ.",
    "brokerAccountWasCreated": "Брокерский счет был успешно добавлен",
    "connectBrokerAccount": "Подключение счета",
    "incomeChartTitle": "График доходности",
    "moreDetails": "Подробнее",
    "downloadReport": "Скачать отчёт",
    "currencies": "Валюты",
    "operations": "Операции",
    "operationsTableName": "Наименование",
    "operationsTableDate": "Дата",
    "operationsTableAmount": "Сумма",
    "openedPositionsTableTicker": "Тикер",
    "openedPositionsTableQuantity": "Кол-во штук",
    "openedPositionsTableEntryPrice": "Цена входа",
    "openedPositionsTableCurrentPrice": "Текущая цена",
    "openedPositionsTableBuyAmount": "Цена покупки",
    "openedPositionsTableResult": "Результат",
    "openedPositionsTableTotalValue": "Стоимость",
    "fillTheProfile": "Заполните, пожалуйста, профиль.",
    "fillTheProfileAction": "Заполнить профиль",
    "noAccountsDescription": "Вы не сможете отслеживать динамику и аналитику портфеля, не подключив свой счет.",
    "noAccountsAction": "Подключить счёт",
    "recommendations": "Рекомендации",
    "recommendedOrderStatus": "Статус",
    "recommendedOrderQuantity": "Кол-во",
    "recommendedOrderPrice": "Цена",
    "recommendedOrderTotal": "Сумма",
    "recommendedOrderHoursAgo": "{{hours}} ч.",
    "recommendedOrderDaysAgo": "{{days}} д.",
    "sharesproOffers": "Предложения SharesPro",
    "p2pOffers": "Предложения участников",
    "investorsOffers": "Предложения инвесторов",
    "allItems": "Все",
    "productsTitle": "Продукты",
    "strategiesTitle": "Стратегии",
    "strategy1Title": "Консервативная стратегия",
    "strategy1Subtitle": "11% в год",
    "strategy1Text": "Максимально надёжный подход к защите капитала",
    "strategy2Title": "Криптовалютная стратегия",
    "strategy2Subtitle": "42% в год",
    "strategy2Text": "Высокая доходность и повышенные риски",
    "strategy3Title": "TECH стратегия",
    "strategy3Subtitle": "22% в год",
    "strategy3Text": "Рост капитала в долгосрочной перспективе",
    "servicesTitle": "Услуги",
    "service1Title": "Паспорт Вануату",
    "service1Text": "Возможность безвизового въезда в 131 страну.",
    "service2Title": "Виза B1/B2 США",
    "service2Text": "Возможность вести бизнес и путешествовать по США без ограничений в течение 3 лет",
    "service3Title": "ВНЖ в ОАЭ",
    "service3Text": "Возможность вести бизнес в ОАЭ без рисков и ограничений.",
    "service4Title": "Карты",
    "service4Text": "Оформление карты иностранного банка в Турции, Казахстане и Таджикистане.",
    "service5Title": "Налоговое планирование",
    "service5Text": "Легальная оптимизация налоговой нагрузки инвестора.",
    "service6Title": "Перевод активов",
    "service6Text": "Перевод средств с подсанкционных брокеров с целью исключения возможных рисков.",
    "myRecommendations": "Мои рекомендации",
    "navTrends": "Что купить",
    "recommendationNumber": "Рекомендация №{{id}}",
    "openedPositionsTableQuantityCell": "{{quantity}} по {{price}}",
    "buyOrderRequest": "Заявка на покупку",
    "sellOrderRequest": "Заявка на продажу",
    "peOffers": "PE предложения",
    "pePrice": "Цена",
    "peSharesQuantity": "Кол-во акций",
    "peOfferPrice": "Сумма предложения",
    "peLastRoundPrice": "Цена последнего раунда",
    "peLastRoundDate": "Дата последнего раунда",
    "peLastRoundVolume": "Объем последнего раунда",
    "leaveRequest": "Оставить заявку",
    "profileUpdated": "Профиль успешно обновлен",
    "peCreateOrderOperationLabel": "Что вы хотие сделать",
    "peCompanyEstimateFromAnalytics": "Оценка аналитиков",
    "peCompanyClients": "Клиенты",
    "peCompanyInvestmentsHistory": "История финансирования",
    "peCompanyInvestmentsChart": "График финансирования",
    "peCompanyAssets": "В портфеле",
    "peEstimateProduct": "Продукт",
    "peEstimateIndustry": "Отрасль",
    "peEstimateInvestors": "Инвесторы",
    "peEstimatePartners": "Партнеры",
    "peEstimateCompetitors": "Конкуренты",
    "peEstimateFinances": "Финансы",
    "peEstimateTeam": "Команда",
    "peEstimateReputation": "Репутация",
    "peEstimateClients": "Оценка клиентов",
    "peFinanceHistoryDate": "Дата",
    "peFinanceHistoryType": "Тип",
    "peFinanceHistoryRaised": "Привлечено, $млн",
    "peFinanceHistoryLeadInvestors": "Ведущие инвесторы",
    "peCompetitorsEstimate": "Оценка",
    "peCompetitorsStockType": "Размещение",
    "peCompetitorsTypeOfRevenueGrowth": "Выручка",
    "peCompetitorsRaised": "Привлечено",
    "peCompetitorsEmployees": "Сотрудников",
    "peCompetitorsCountry": "Страна",
    "peCompetitorsFoundation": "Основание",
    "peAssetAccount": "Счёт",
    "peAssetQuantity": "Количество",
    "peAssetAmount": "Стоимость",
    "peAssetIncome": "Доходность",
    "quantityWithSuffix": "{{quantity}} шт.",
    "peCompanySharesPrice": "Цена за акцию",
    "peCreateOrderCompanyName": "Название компании которую вы хотите купить",
    "peCreateOrderAmount": "Сумма",
    "peCreateOrderSharePrice": "Цена покупки акций",
    "peCreateOrderComment": "Дополнительные комментарии или вопросы",
    "peCreateOrderQuantity": "Количество",
    "peYourRequestWasSent": "Ваша заявка отправлена!",
    "peManagerWillContactYou": "Менеджер свяжется с вами в ближайшее время.",
    "peOrder": "Заявка",
    "status": "Статус",
    "peActiveTotalAmount": "Сумма актива",
    "peActivePurchaseTotalAmount": "Сумма покупки",
    "peActiveRevenuePercent": "Доходность",
    "orderStateActive": "Активные",
    "orderStateArchived": "Архивные",
    "peDealStateActive": "Активные",
    "peDealStateArchived": "Архивные",
    "raised": "Привлечено",
    "allChats": "Все чаты",
    "peEstimateActionBuy": "Покупать",
    "peEstimateActionHold": "Удерживать",
    "peEstimateActionSell": "Продавать",
    "pageOf": "Страница {{current}} из {{total}}",
    "requestCallManagerServiceText": "Хотите связаться с менеджером для получения более подробной информации об услуге?",
    "requestCallManagerProductText": "Хотите связаться с менеджером для получения более подробной информации о продукте?",
    "requestCallManagerStrategyText": "Хотите связаться с менеджером для получения более подробной информации о стратегии?",
    "requestCallManagerAccept": "Да, свяжите с менеджером",
    "requestCallManagerDecline": "Нет, спасибо",
    "requestCallManagerSuccess": "Спасибо за оставленную заявку! Наш менеджер будет рад ответить на ваши вопросы.",
    "submitRequest": "Подать заявку",
    "requestCallManagerNotificationText": "Хотите связаться с менеджером для получения более подробной информации?",
    "peSidebarRequestCardText": "Покупка доли непубличных компаний в рамках частных раундов финансирования до выхода на IPO.  ",
    "skolkovoResidentTitle": "Резидент инновационного центра \"Сколково\"",
    "skolkovoResidentDescription": "Исследования осуществляются ООО \"ШАРЕСПРО\" при грантовой поддержке Фонда \"Сколково\"",
    "copyright1": "Все права защищены. Полное или частичное копирование материалов Сайта в коммерческих целях разрешено только с письменного разрешения владельца Сайта. В случае обнаружения нарушений, виновные лица могут быть привлечены к ответственности в соответствии с действующим законодательством Российской Федерации.",
    "copyright2": "* - Данные Услуги оказываются партнером \"SharesPro Consulting\"",
    "copyright3": "© SharesPro {{year}}",
    "addressLabel": "Адрес",
    "addressValue": "109028, Москва, Подкопаевский пер., д. 4, корп. А, 4 этаж",
    "privacyPolicy": "Политика обработки персональных данных",
    "userAgreement": "Пользовательское соглашение",
    "soutResults": "Результаты СОУТ",
    "strategy1Advantage1Label": "Превосходим динамику VWIAX на",
    "strategy1Advantage2Label": "Среднегодовая волотильность",
    "strategy1Advantage3Label": "Среднегодовая доходность",
    "strategy1Advantage4Label": "Лучшая доходность за год",
    "strategy1Advantage5Label": "Лет с отрицательной доходностью",
    "strategy1Advantage6Label": "Лет с положительной доходностью",
    "strategy1Advantage7Label": "Худшая доходность за год",
    "strategy1Advantage8Label": "Лет с доходностью выше 5%",
    "strategy1Advantage1Value": "1,60%",
    "strategy1Advantage2Value": "5,03%",
    "strategy1Advantage3Value": "8,52%",
    "strategy1Advantage4Value": "15,20%",
    "strategy1Advantage5Value": "0 из 7",
    "strategy1Advantage6Value": "7 из 7",
    "strategy1Advantage7Value": "0.51%",
    "strategy1Advantage8Value": "4 из 7",
    "strategy2Advantage1Label": "Превосходим динамику Bitcoin на",
    "strategy2Advantage2Label": "Среднегодовая волотильность",
    "strategy2Advantage3Label": "Среднегодовая доходность",
    "strategy2Advantage4Label": "Лучшая доходность за год",
    "strategy2Advantage5Label": "Лет с отрицательной доходностью",
    "strategy2Advantage6Label": "Лет с положительной доходностью",
    "strategy2Advantage7Label": "Худшая доходность за год",
    "strategy2Advantage8Label": "Лет с доходностью выше 10%",
    "strategy2Advantage1Value": "143,00%",
    "strategy2Advantage2Value": "71,30%",
    "strategy2Advantage3Value": "239,30%",
    "strategy2Advantage4Value": "650,10%",
    "strategy2Advantage5Value": "1 из 4",
    "strategy2Advantage6Value": "3 из 4",
    "strategy2Advantage7Value": "-65,10%",
    "strategy2Advantage8Value": "3 из 4",
    "strategy3Advantage1Label": "Превосходим динамику NASDAQ на",
    "strategy3Advantage2Label": "Среднегодовая волотильность",
    "strategy3Advantage3Label": "Среднегодовая доходность",
    "strategy3Advantage4Label": "Лучшая доходность за год",
    "strategy3Advantage5Label": "Лет с отрицательной доходностью",
    "strategy3Advantage6Label": "Лет с положительной доходностью",
    "strategy3Advantage7Label": "Худшая доходность за год",
    "strategy3Advantage8Label": "Лет с доходностью выше 10%",
    "strategy3Advantage1Value": "52,00%",
    "strategy3Advantage2Value": "58,50%",
    "strategy3Advantage3Value": "67,20%",
    "strategy3Advantage4Value": "167,00%",
    "strategy3Advantage5Value": "1 из 9",
    "strategy3Advantage6Value": "8 из 9",
    "strategy3Advantage7Value": "-30,50%",
    "strategy3Advantage8Value": "8 из 9",
    "strategyIndicators": "Показатели стратегии",
    "strategyIndicatorRisk": "Риск",
    "strategyIndicatorLongTerm": "Долгосрочность",
    "strategyIndicatorYield": "Доходость",
    "strategyIndicatorReliability": "Надежность",
    "strategyModelIncomeTitle": "Модельная доходнодность с 2015 года",
    "strategyModelIncome": "Доходнодность",
    "strategyPortfolioComposition": "Состав портфеля",
    "advantages": "Преимущества",
    "aboutStrategy": "О стратегии",
    "strategyPortfolio": "В портфеле",
    "strategyIncomeChart": "График доходности",
    "strategyApplyCardDescription": "Для отображения состава стратегии, Вам необходимо стать клиентом SharesPro.",
    "strategyApply": "Подать заявку",
    "strategyEntryThreshold": "Порог входа",
    "peTabInfo": "Информация",
    "peTabNews": "Новости",
    "peTabOrderBook": "Стакан",
    "survey": "Опрос",
    "generalSurveyQuestion1": "Оцените качество сервиса SharesPro",
    "generalSurveyQuestion2": "Оцените качество инвестиционных предложений SharesPro",
    "generalSurveyQuestion3": "Какова вероятность того, что вы будете рекомендовать SharesPro вашим знакомым?",
    "generalSurveyQuestion4": "Что мы могли бы изменить, чтобы Вы поставили нам 10?",
    "finishSurvey": "Закончить опрос",
    "yourAnswer": "Ваш ответ",
    "generalSurveyOfferCard": "Пожалуйста, пройдите опрос качества работы Sharespro",
    "startSurvey": "Начать",
    "thanksForSurveyFeedback": "Спасибо за обратную связь",
    "noData": "Нет данных",
    "orderBookIsEmpty": "Стакан пуст",
    "chartDataIsPreparing": "Данные обрабатываются. Процесс может занять несколько часов.",
    "orderTableBuy": "На покупку",
    "orderTableSell": "На продажу",
    "videoFromEvent": "Запись встречи",
    "photosFromEvent": "Фото встречи",
    "eventTopics": "Темы мероприятия",
    "eventInvestmentsDirections": "Направления инвестирования",
    "eventVideoReviews": "Видео отзывы",
    "eventDescription": "Описание",
    "eventDownloadPresentation": "Скачать презентацию",
    "eventRegister": "Зарегистрироваться",
    "nextEventHasNotScheduledYet": "Следующее мероприятие ещё не назанчено",
    "singUpForTheWaitingList": "Запись в лист ожидания",
    "nextEvents": "Предстоящие события",
    "prevEvents": "Прошедшие события",
    "sharesproStrategies": "Стратегии SharesPro",
    "upcomingEvents": "Ближайшие мероприятия",
    "youJoinedToEvent": "Вы зарегистрированы на мероприятие",
    "youRegisteredToWaitingList": "Вы записаны в лист ожиданий",
    "eventStatusUpcomingTag": "Записаться",
    "eventStatusArchivedTag": "Архив",
    "declineAction": "Отклонить",
    "connectFreedomTitle": "Подключение Freedom",
    "connectFinam": "Подключение Финам",
    "finamBrokerConnectStep1_1": "Пройдите регистрацию в ",
    "finamBrokerConnectStep1_2": "Comon",
    "finamBrokerConnectStep1_3": ", используя номер телефона связанный с вашим счётом в Финам.",
    "finamBrokerConnectStep2_1": "Для создания токена в Comon, перейдите ",
    "finamBrokerConnectStep2_2": "по ссылке",
    "finamBrokerConnectStep2_3": ". Или Личный кабинет > Счета > Trade API. Нажмите кнопку Создать токен.",
    "finamBrokerConnectStep3": "Выберите счёт, введите название токена, укажите тип-Торговый.",
    "finamBrokerConnectStep4": "Поставьте галочку, бессрочный.",
    "finamBrokerConnectStep5": "Скопируйте и вставьте в поле счёт токена.",
    "finamBrokerConnectStep6": "Скопируйте и вставьте в поле токен.",
    "finamAccountField": "Счёт",
    "finamTokenField": "Токен",
    "stateOfPortfolio": "Состояние вашего портфеля",
    "myAccount": "Мой аккаунт",
    "minNumValue": "Минимальное допустимое значение для ввода: {{amount}}",
    "improveAppFeedbackTitle": "Как нам стать лучше?",
    "improveAppFeedbackText": "Пожалуйста, пройдите опрос качества работы SharesPro",
    "improveAppFeedbackFillForm": "Пройти опрос",
    "improveAppFeedbackEverythingIsGood": "Все нравится",
    "cryptoAccount": "Крипто портфель",
    "peAccount": "IPO/PE",
    "arbitrAccount": "Арбитражная торговля",
    "updatePhoto": "Обновить фото",
    "addProfilePhoto": "Добавить фото",
    "fileTooBigMb": "Размер файла не может превышать {{size}} MiB.",
    "newRecommendations": "Новые рекомендации",
    "pleaseApproveRecommendations": "Пожалуйста, одобрите рекомендации:",
    "pleaseApproveRebalancing": "Пожалуйста, одобрите ребалансировку:",
    "approveAllRecommendations": "Одобрить",
    "privateChannel": "Закрытый канал",
    "noAccess": "Нет доступа",
    "commentariesCount1": "{{count}} комментарий",
    "commentariesCount2": "{{count}} комментария",
    "commentariesCount3": "{{count}} комментарий",
    "commentariesCount4": "{{count}} комментариев",
    "leaveAComment": "Прокомментировать",
    "commentEdited": "изменено",
    "commentsDiscussion": "Обсуждение",
    "comments": "Коментарии",
    "commentInputPlaceholder": "Комментарий...",
    "commentWasDeleted": "Комментарий успешно удален",
    "commentWasAdded": "Комментарий успешно добавлен",
    "commentWasUpdated": "Комментарий успешно обновлен",
    "loadMore": "Загрузить ещё",
    "editComment": "Редактирование комментария",
    "privateChannelNoAccessTitle": "Вы не являетесь членом сообщества",
    "privateChannelNoAccessText": "Нам жаль, что вы пока не явлетесь членом нашего сообщетсва и не можете просматривать экслюзивую информацию, обзоры аналитиков и приватные обсуждения.",
    "joinCommunity": "Вступить в сообщество",
    "privateChannelRequestSent": "Заявка на приватный канал успешно отправлена",
    "assetSum": "Cумма актива",
    "entryPrice": "Цена покупки",
    "eventManager": "Менеджер мероприятий",
    "allOrdersHaveBeenApproved": "Все рекомендации были успешно одобрены.",
    "binanceTitle": "Бинанс",
    "connectBinance": "Подключение Бинанс",
    "binanceApiKeyField": "API key",
    "binanceSecretKeyField": "Secret key",
    "binanceBrokerConnectStep1_1": "Авторизируйтесь в личном кабинете ",
    "binanceBrokerConnectStep1_2": "по ссылке.",
    "binanceBrokerConnectStep2": "Выберите Профиль — Управление API.",
    "binanceBrokerConnectStep3_1": "Нажмите создать API. Перед началом, убедитесь, что активирована ",
    "binanceBrokerConnectStep3_2": "двухфакторная аутентификация",
    "binanceBrokerConnectStep3_3": ", внесена любая сумма для активации аккаунта.",
    "binanceBrokerConnectStep4": "Выберите системный тип API-ключа.",
    "binanceBrokerConnectStep5": "Введите метку/название API-ключа.",
    "binanceBrokerConnectStep6": "Подтвердите запрос с помощью устройства для двухфакторной аутентификации.",
    "binanceBrokerConnectStep7": "Активируйте методы управления безопасностью, убрав галочку.",
    "binanceBrokerConnectStep8": "Поставьте галочки: Разрешить чтение и Включить спотовую и маржинальную торговлю.",
    "binanceBrokerConnectStep9": "Скопируйте и вставьте в поля API key и Secret key.",
    "hintScreen": "Скрин-подсказка",
    "mainIntroTitle": "Консультант по системному инвестированию на фондовых рынках",
    "featuresSectionTitle": "Что получает клиент SharesPro",
    "leaveWithdrawalRequestPlease": "Пожалуйста, для вывода средств оставьте заявку",
    "viewWithdrawalRequests": "Посмотреть заявки",
    "requestCreating": "Создание заявки",
    "withdrawalFromAccount": "Вывод со счета",
    "currency": "Валюта",
    "wallet": "Кошелек",
    "createRequest": "Создать заявку",
    "withdrawalRequests": "Заявки на вывод",
    "requestWaitingProcessing": "Ожидает обработки",
    "requestProcessing": "В обработке",
    "requestDone": "Исполнено",
    "requestRejected": "Отклонено",
    "withdrowalAmount": "Сумма",
    "withdrawalRequestCreatedSuccessfully": "Запрос на вывод средств успешно создан",
    "orderStatusCanceled": "Отмененный",
    "withdrawalOrderDate": "Дата заявки",
    "withdrawalOrderAmount": "Сумма заявки",
    "walletAddress": "Кошелек",
    "myDocuments": "Мои документы",
    "sign": "Подписать",
    "awaitSign": "Ожидает подписания",
    "signed": "Подписано",
    "signDocSms": "Для подписания документа, \nукажите код из SMS",
    "homeDocCardTitle": "Документы на подпись",
    "homeDocCardDescription": "Пожалуйста, ознакомьтесь и подпишите документы",
    "document": "Документ",
    "codeHasBeenSendToNumberDocument": "Мы отправили SMS на номер",
    "declineVote": "Отменить голос",
    "byte": "б",
    "kilobyte": "Кб",
    "megabyte": "Мб",
    "gigabyte": "Гб",
    "privateChat": "Закрытый Чат",
    "investGroup": "Группа Инвест Клуба",
    "telegramTitle": "Чтобы получать в Telegram SMS-коды и копии\nпуш-уведомлений из приложения SharesPro,\nподключите телеграм канал. Его можно найти\nпо имени @SharesPro_bot или по",
    "telegramTitleLink": "ссылке",
    "telegramFirst": "Начните диалог с ботом с помощью\nкоманды /start",
    "telegramSecond": "Введите номер телефона в\nмеждународном формате, по\nкоторому вы входите в приложение\nSharesPro",
    "telegramThird": "Вам придет SMS-сообщение с кодом,\nкоторый надо прислать в диалог с\nботом",
    "disable": "Отключить",
    "enable": "Как подключить",
    "codeMethod": "Способ получения кодов",
    "disableTelegram": "Вы уверены, что хотите отключить Telegram?",
    "enabled": "Подключено",
    "disabled": "отключен",
    "connectionTelegram": "Подключение Telegram",
    "compensationCardTitle": "Компенсация",
    "compensationCardText": "Вам доступна компенсация по сделке Convoy",
    "compensationPageTitle": "Компенсации",
    "noCompensationAvailable":"Компенсации не доступны",
    "accrualCompensation":"начисление",
    "writeOffCompensation":"списание",
    "compensationPageTextFirst": "В случае банкротств (или других возможных убытков) компания может принять решение о компенсации этих убытков за счет собственных комиссий.",
    "compensationPageTextSecond": "В разделе вы можете увидеть, есть ли компенсация по вашим сделкам и отслеживать прогресс её остатка.",
    "balanceCompensation": "Остаток компенсации ",
    "lock-up": "Lock-up",
    "editAccountName": "Переименовать счет",
    "amountIsRequired": "Сумма обязательна",
    "amountIsLow": "Сумма должна быть больше 1",
    "amountExceedsAvailable": "Сумма превышает доступную для вывода",
    "currencyIsRequired": "Валюта обязательна",
    "walletIsRequired": "Кошелек обязателен",
    "availableForWithdrawal": "Доступно для вывода",
    "available": "Доступно",
    "selfIpoTitle": "IPO",
    "selfIpoApplicationsTitle": "Мои IPO заявки",
    "selfIpoApplicationsProfileButton": "IPO заявки",
    "selfIpoApplicationsActiveTab": "Активные",
    "selfIpoApplicationsCancelledTab": "Отмененные",
    "selfIpoAmount": "Сумма",
    "selfIpoPriceRange": "Диапазон цены",
    "selfIpoMinAmount": "Минимальная сумма",
    "selfIpoAcceptanceDeadline": "Дедлайн подачи",
    "selfIpoDeadlineShort": "до {{date}}",
    "selfIpoApplicationsCount": "Количество заявок",
    "selfIpoCardOpenStatus": "Открыта",
    "selfIpoCardClosedStatus": "Закрыта",
    "selfIpoOpenForApplications": "Приём открыт",
    "selfIpoClosedForApplications": "Приём закрыт",
    "selfIpoEligibilityReady": "Можно подать заявку",
    "selfIpoEligibilityNoPortfolio": "Нет Self IPO портфеля. Обратитесь к менеджеру",
    "selfIpoEligibilityBookClosed": "Дедлайн истёк, приём заявок закрыт",
    "selfIpoEligibilityInsufficientBalance": "Недостаточно средств на балансе портфеля",
    "selfIpoEligibilityAlreadyApplied": "Заявка на эту карточку уже подана",
    "selfIpoCurrentApplication": "Текущая заявка",
    "selfIpoSubmittedAt": "Дата подачи",
    "selfIpoCashBalance": "Свободные средства",
    "selfIpoHoldBalance": "Заблокированные средства",
    "selfIpoAssetBalance": "Стоимость активов",
    "selfIpoBalance": "Баланс",
    "selfIpoPortfolio": "Портфель",
    "selfIpoDealFee": "Комиссия за сделку",
    "selfIpoSuccessFee": "Комиссия за успех",
    "selfIpoLockUpDays": "Lock-up, дней",
    "selfIpoSector": "Сектор",
    "selfIpoDescription": "Описание",
    "selfIpoStatusSubmitted": "Подана",
    "selfIpoStatusAllocated": "Аллоцирована",
    "selfIpoStatusNotAllocated": "Аллокации нет",
    "selfIpoStatusClosed": "Закрыта",
    "selfIpoStatusCancelled": "Отозвана",
    "selfIpoAllocationPercent": "Аллокация, %",
    "selfIpoAllocatedAmount": "Аллоцированная сумма",
    "selfIpoBuyPrice": "Цена покупки",
    "selfIpoBuyQuantity": "Количество акций",
    "selfIpoBuyDate": "Дата покупки",
    "selfIpoUnlockDate": "Дата разблокировки",
    "selfIpoProfitPercent": "Текущая прибыль, %",
    "selfIpoFixedProfitPercent": "Зафиксированная прибыль, %",
    "selfIpoApplyAction": "Подать заявку",
    "selfIpoContactManagerAction": "Связаться с менеджером",
    "selfIpoTopUpAction": "Пополнить баланс",
    "selfIpoApplyAmountLabel": "Сумма заявки, $",
    "selfIpoApplySuccess": "Заявка успешно отправлена",
    "selfIpoContactManagerSuccess": "Заявка отправлена. Менеджер свяжется с вами",
    "selfIpoTopUpSuccess": "Запрос на пополнение баланса отправлен",
    "selfIpoCancelSuccess": "Заявка успешно отозвана",
    "selfIpoCancelConfirmation": "Вы уверены, что хотите отозвать заявку?",
    "selfIpoMinAmountValidation": "Минимальная сумма заявки: {{amount}}$",
    "selfIpoAmountExceedsAllowed": "Сумма превышает допустимую",
    "selfIpoCashBalanceHelper": "Свободные средства: {{amount}}$",
    "createNewChat": "Создать новый чат",
    "ai": "ИИ",
    "newChat": "Новый чат",
    "noChatsFound": "Чаты не найдены",
    "selectChatFromList": "Выберите чат из списка слева",
    "enterMessage": "Введите сообщение...",
    "errorCreatingChat": "Ошибка при создании чата:",
    "errorSendingMessage": "Ошибка при отправке сообщения:",
    "aiChat": "ИИ чат",
    "confirmDeleteTitle": "Удалить чат",
    "confirmDeleteBody": "Вы уверены, что хотите удалить этот чат? Это действие необратимо.",
    "autofollowActive": "Автоследование активно",
    "pauseAutofollow": "Приостановить автоследование",
    "pauseAutofollowConfirmationText": "Стратегия работает в штатном режиме. Нажмите «Подтвердить», если хотите временно остановить торговлю - все активы будут автоматически проданы, а следование стратегии отключено.\n\n⚠️ Внимание: продажа активов происходит по рыночным ценам и может быть невыгодной в момент высокой волатильности. Возобновить стратегию можно только вручную через приложение.",
    "autofollowPaused": "Автоследование приостановлено",
    "resumeAutofollow": "Возобновить автоследование",
    "resumeAutofollowConfirmationText": "Стратегия отключена. Чтобы возобновить участие, нажмите кнопку «Подтвердить» и портфель начнёт формироваться заново.\n\n⚠️Внимание: текущие позиции на счете будут закрыты для формирования портфеля стратегии.",
    "privacyPolicyLink": "обработку персональных данных",
    "termsOfServiceLink": "пользовательского соглашения",
    "mondayShort": "пн",
    "tuesdayShort": "вт",
    "wednesdayShort": "ср",
    "thursdayShort": "чт",
    "fridayShort": "пт",
    "saturdayShort": "сб",
    "sundayShort": "вс",
    "januaryGenitive": "января",
    "februaryGenitive": "февраля",
    "marchGenitive": "марта",
    "aprilGenitive": "апреля",
    "mayGenitive": "мая",
    "juneGenitive": "июня",
    "julyGenitive": "июля",
    "augustGenitive": "августа",
    "septemberGenitive": "сентября",
    "octoberGenitive": "октября",
    "novemberGenitive": "ноября",
    "decemberGenitive": "декабря",
  }
}

export default ru;
